<template>
  <div class="route-view dark login-from">
    <language-switch />
    <div class="logo">
      <img src="/images/logo.png" />
    </div>
    <div class="panel">
      <div class="panel-content">
        <auth-menu selected-menu="login" />
        <form @submit.prevent="handleLogin">
          <div class="field">
            <label for="" class="label">{{ $t('login.phoneLabel') }}</label>
            <div class="control has-icons-left">
              <input
                v-model="username"
                type="text"
                :placeholder="$t('login.phoneLabel')"
                class="input text-center"
                required
                @input="handlerInput"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label">{{ $t('login.passwordLabel') }}</label>
            <div class="control has-icons-left">
              <input
                v-model="password"
                type="password"
                :placeholder="$t('login.passwordLabel')"
                class="input text-center"
                required
                @input="handlerInput"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </div>
          </div>
          <div class="error has-text-centered m-t-10">
            {{ error }}
          </div>
          <div class="text-center">
            <button type="submit" class="button full-50 is-primary">
              {{ $t('login.loginBtn') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AuthMenu from '@/components/AuthMenu'
import LanguageSwitch from '@/components/LanguageSwitch'

export default {
  name: 'Login',
  components: { AuthMenu, LanguageSwitch },
  props: {
    page: String
  },
  data() {
    return {
      username: null,
      password: null,
      isRemember: false,
      error: null,
      langIcon: null,
      selectedMenu: 'login'
    }
  },
  created() {
    this.$emit('childinit', this.page)
  },
  mounted() {},
  methods: {
    ...mapActions('auth', ['login']),

    handleLogin() {
      if (!this.username) return false
      if (!this.password) return false

      this.login({
        username: this.username,
        password: this.password,
        isRemember: this.isRemember
      })
        .then(() => {})
        .catch(error => {
          this.error = error
        })
      // e.preventDefault()
    },

    handlerInput() {
      if (this.error) {
        this.error = null
      }
    }
  }
}
</script>
